import Vue from "vue";
import { createChannel, listChannels, updateChannel, deleteChannel } from "../../api/channel";

const channel = {
    namespaced: true,
    state: {
        channels: [],
    },
    getters: {
        whatsappBusinessChannelExists: (state) => {
            return !!state.channels.find((x) => x.type === "whatsapp-business-api" && x.enabled);
        },
    },
    mutations: {
        ADD_CHANNEL: (state, channel) => {
            state.channels = [...state.channels, channel];
        },
        SET_CHANNELS: (state, channels) => {
            state.channels = channels;
        },
        UPDATE_CHANNEL: (state, payload) => {
            let index = state.channels.findIndex((p) => p._id === payload._id);
            if (index === -1) {
                Vue.set(state.channels, index, {
                    ...state.channels[index],
                    ...payload,
                });
            }
        },
        DELETE_CHANNEL: (state, channelId) => {
            state.channels = state.channels.filter((p) => p._id !== channelId);
        },
    },
    actions: {
        listChannels({ commit }) {
            return listChannels()
                .then((response) => {
                    commit("SET_CHANNELS", response.data);
                    return response.data;
                })
                .catch((error) => {
                    console.log("listChannels error...", error);
                });
        },
        getChannel({ state }, id) {
            return state.channels.find((p) => p._id === id);
        },
        createChannel({ commit }, payload) {
            return createChannel(
                payload.type,
                payload.name,
                payload.chatbotStory,
                payload.payload,
                payload.visibility
            ).then((response) => {
                commit("ADD_CHANNEL", response.data);
                return response.data;
            });
        },
        updateChannel({ commit }, payload) {
            return updateChannel(
                payload._id,
                payload.name,
                payload.enabled,
                payload.chatbotStory,
                payload.payload,
                payload.visibility
            ).then((response) => {
                const isSuccess = response.data;
                if (isSuccess) {
                    commit("UPDATE_CHANNEL", payload);
                }
                return isSuccess;
            });
        },
        deleteChannel({ commit }, channelId) {
            return deleteChannel(channelId).then((response) => {
                const isSuccess = response.data;
                if (isSuccess) {
                    commit("DELETE_CHANNEL", channelId);
                }
                return isSuccess;
            });
        },
    },
};

export default channel;
